import { dataTableDefaults } from './dataTable';
import { filterDefaults } from './filter';
import { reportDefaults } from './report';

export default {
    dataTable: dataTableDefaults,
    filter: filterDefaults,
    report: reportDefaults,
    isLegendActive: false,
};
